export const adjustArray = (elements: any[], desiredCount: number) => {
  elements.sort((a, b) => a.blockId - b.blockId);

  if (elements.length > desiredCount) {
    return elements.slice(0, desiredCount);
  }

  return elements;
};
